import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgRotateToPortrait = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 81 69"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <rect
            width={31}
            height={60}
            x={-2}
            y={2}
            stroke="#B3B3B3"
            strokeWidth={4}
            rx={2}
            transform="matrix(-1 0 0 1 76.552 2)"
        />
        <path
            stroke="#222"
            strokeLinecap="round"
            strokeWidth={4}
            d="M39.552 29H5.724a3.17 3.17 0 0 0-3.172 3.172v28.656A3.17 3.17 0 0 0 5.724 64h33.828"
        />
        <path
            stroke="#222"
            strokeLinecap="round"
            strokeWidth={3}
            d="M9.954 17.558C16.718 6.447 25.44 5.205 34.897 8.228m0 0-.998-2.968m.998 2.969-3.008 2.134"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgRotateToPortrait)
const Memo = memo(ForwardRef)
export default Memo
